import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = localStorage.getItem('debugStimulus') === 'true';
window.Stimulus   = application;

export { application }
